<template>
  <div class="alert-overview">
    <div class="alert-row">
      <div class="alert-title">
        <div class="square"></div>
        <div class="title">安防告警</div>
      </div>
      <div class="container-box">
        <div class="alert-item">
          <div>
            <img src="../../../common/assets/images/screen/security/alarmCount.png" alt="" width="40" height="40">
          </div>
          <div class="right">
            <div class="label">今日告警数</div>
            <div class="value alarm">{{ info.alarmCount }}</div>
          </div>
        </div>
        <div class="alert-item">
          <div>
            <img src="../../../common/assets/images/screen/security/orderCount.png" alt="" width="40" height="40">
          </div>
          <div class="right">
            <div class="label">今日工单数</div>
            <div class="value order">{{ info.alarmWorkOrderCount }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="alert-row">
      <div class="alert-title">
        <div class="square"></div>
        <div class="title">电子巡更</div>
      </div>
      <div class="container-box">
        <div class="alert-item">
          <div>
            <img src="../../../common/assets/images/screen/security/partolCount.png" alt="" width="40" height="40">
          </div>
          <div class="right">
            <div class="label">今日任务数</div>
            <div class="value alarm">{{ patrol.patrolTasksTot }}</div>
          </div>
        </div>
        <div class="alert-item">
          <div>
            <img src="../../../common/assets/images/screen/security/finishCount.png" alt="" width="40" height="40">
          </div>
          <div class="right">
            <div class="label">今日完成数</div>
            <div class="value order">{{ patrol.patrolTasksFinish }}</div>
          </div>
        </div>
        <div class="alert-item">
          <div>
            <img src="../../../common/assets/images/screen/security/unFinishCount.png" alt="" width="38" height="40">
          </div>
          <div class="right">
            <div class="label">今日未执行数</div>
            <div class="value order">{{ patrol.patrolTasksUnexecuted }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      info: {
        alarmCount: null,
        alarmWorkOrderCount: null,
      },
      patrol: {
        patrolTasksTot: null,
        patrolTasksFinish: null,
        patrolTasksUnexecuted: null
      }
    }
  },
  mounted() {
    this.queryAlarm()
    this.queryCount()
  },
  methods: {
    async queryAlarm() {
      const { success, returnObj } = await this.$fetch('/dep/comprehensiveSituation/statisticsAlarmTotal.json', {
        "alarmTypeList": [],
        "subSystemList": [5, 9, 10, 11, 17]
      })
      if (success) {
        this.info.alarmCount = returnObj.alarmCount
        this.info.alarmWorkOrderCount = returnObj.alarmWorkOrderCount
      }
    },
    async queryCount() {
      const { success, returnObj } = await this.$fetch('/dep/comprehensiveSituation/electronicPatrolSituation.json')
      if (success) {
        console.log(returnObj)
        this.patrol.patrolTasksTot = returnObj.patrolTasksTot
        this.patrol.patrolTasksFinish = returnObj.patrolTasksFinish
        this.patrol.patrolTasksUnexecuted = returnObj.patrolTasksUnexecuted
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.alert-overview {
  width: 100%;
  height: 100%;

  .alert-row {
    padding: 10px;
    margin-bottom: 15px;

    .alert-title {
      display: flex;
      align-items: center;

      .square {
        width: 10px;
        height: 10px;
        background-color: #05f4ff;
        margin-right: 10px;
      }

      .title {
        width: 100%;
        height: 30px;
        line-height: 30px;
        font-size: 18px;
        font-weight: 700;
        background-clip: text;
        color: #ffffff;
      }
    }
  }

  .container-box {
    display: flex;
    flex-wrap: wrap;
    max-height: 350px;
    overflow-y: auto;

    .alert-item {
      width: 210px;
      height: 70px;
      display: flex;
      align-items: center;

      .right {
        display: flex;
        flex-direction: column;
        margin-left: 20px;

        .label {
          font-size: 17px;
          font-weight: 600;
          color: #ffffff;
          padding: 5px 0;
        }

        .value {
          font-size: 25px;
          font-weight: 600;
          padding: 5px 0;
          color: #ffffff;
        }
      }
    }
  }
}
</style>